import {
  ProductInformationTab,
  ProductLocationTab,
  ProductExtrasTab,
  ProductAvailabilityTab,
} from './product-detail'
import { SupplierInformationTab } from './supplier-detail'
import { SupplierContactsTab } from './supplier-detail/supplier-contacts'
import {
  TemplateSidebarTodoTab,
  TemplateSideBarClientProfile,
} from './template-sidebar'

import {
  GlobalSearchAllTab,
  GlobalSearchCustomersTab,
  GlobalSearchTemplatesTab,
  GlobalSearchWeekOrdersTab,
} from './global-search'

import {
  CustomerUserListTab,
  EmployeeUserListTab
} from './user-list'
import { SystemJobBatchesTab } from './system/system-job-batches'
import { SystemJobsTab } from './system/system-jobs'
import { SystemFailedJobsTab } from './system/system-failed-jobs'

import {
  TagInformationTab,
  TagRelatedProductsTab,
  TagTargetedProductsTab,
  TagRelatedCustomersTab,
} from './tag-detail'

export const ProductDetailTabs = {
  ProductInformationTab,
  ProductLocationTab,
  ProductExtrasTab,
  ProductAvailabilityTab,
}

export const SupplierDetailTabs = {
  SupplierInformationTab,
  SupplierContactsTab,
}

export const GlobalSearchTabs = {
  GlobalSearchAllTab,
  GlobalSearchCustomersTab,
  GlobalSearchTemplatesTab,
  GlobalSearchWeekOrdersTab,
}

export const TemplateSidebarTabs = {
  TemplateSidebarTodoTab,
  TemplateSideBarClientProfile,
}

export const UserListTabs = {
  CustomerUserListTab,
  EmployeeUserListTab
}

export const SystemTabs = {
  SystemJobBatchesTab,
  SystemJobsTab,
  SystemFailedJobsTab,
}

export const TagDetailTabs = {
  TagInformationTab,
  TagRelatedProductsTab,
  TagTargetedProductsTab,
  TagRelatedCustomersTab,
}
